// import Dialog from "@mui/material/Dialog";
// import DialogContent from "@mui/material/DialogContent";
// import DialogTitle from "@mui/material/DialogTitle";
// import Icon from "@mui/material/Icon";
// import IconButton from "@mui/material/IconButton";
// import { useTheme } from "@mui/material/styles";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import PropTypes from "prop-types";

// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import { useMaterialUIController } from "context";

// function ActivityDetailsModal({ open, onClose, task }) {
//   const theme = useTheme();
//   const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
//   const [controller] = useMaterialUIController();
//   const { darkMode } = controller;

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       fullScreen={fullScreen}
//       maxWidth="lg"
//       fullWidth
//       PaperProps={{
//         sx: {
//           backgroundColor: darkMode ? "#1a2035" : "#fff", // same as ConfigProvider example
//           color: darkMode ? "#fff" : "#000",
//           borderRadius: 2,
//         },
//       }}
//     >
//       {/* HEADER */}
//       <DialogTitle
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           color: darkMode ? "#fff" : "#000",
//           backgroundColor: darkMode ? "#1f2937" : "#f5f5f5", // subtle header background
//           borderBottom: `1px solid ${darkMode ? "#475894" : "#d9d9d9"}`,
//         }}
//       >
//         <MDTypography variant="h5">Lead Details</MDTypography>

//         <IconButton onClick={onClose} sx={{ color: darkMode ? "#fff" : "#000" }}>
//           <Icon>close</Icon>
//         </IconButton>
//       </DialogTitle>

//       {/* CONTENT */}
//       <DialogContent
//         dividers
//         sx={{
//           backgroundColor: darkMode ? "#1a2035" : "#fff",
//           "& .MuiTypography-root": {
//             color: darkMode ? "#fff" : "#000",
//           },
//         }}
//       >
//         {data ? (
//           <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={3}>
//             <MDTypography>
//               <b>Lead Name:</b> {task?.lead_details?.leadName}
//             </MDTypography>
//             <MDTypography>
//               <b>Mobile:</b> {task?.lead_details?.mobile1 || "-"}
//             </MDTypography>
//             <MDTypography>
//               <b>Lead State:</b> {task?.leadState}
//             </MDTypography>
//             <MDTypography>
//               <b>Task Type:</b> {task?.taskType}
//             </MDTypography>
//             <MDTypography>
//               <b>Status:</b> {task?.status}
//             </MDTypography>
//             <MDTypography>
//               <b>Scheduled On:</b> {taskScheduled}
//             </MDTypography>
//             <MDTypography>
//               <b>Assigned To:</b> {task.assigned_to}
//             </MDTypography>
//             <MDTypography>
//               <b>Created On:</b> {taskCreated}
//             </MDTypography>
//             <MDTypography>
//               <b>Remark:</b> {task?.creation_remark || "-"}
//             </MDTypography>
//             <MDTypography>
//               <b>Completion Remark:</b> {task?.completion_remark || "-"}
//             </MDTypography>
//             <MDTypography>
//               <b>Property Name:</b> {task?.propertyName || "-"}
//             </MDTypography>
//             <MDTypography>
//               <b>Call Status:</b> {task?.callStatus ? "Yes" : "No"}
//             </MDTypography>
//           </MDBox>
//         ) : (
//           <MDTypography>No data</MDTypography>
//         )}
//       </DialogContent>
//     </Dialog>
//   );
// }

// ActivityDetailsModal.propTypes = {
//   open: PropTypes.bool.isRequired,
//   onClose: PropTypes.func.isRequired,
//   data: PropTypes.object,
// };

// export default ActivityDetailsModal;

/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { leadColors } from "service/Common";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import { format } from "date-fns";
import { useAxiosPrivate } from "hooks/useAxiosPrivate";

function ActivityDetailsModal({ open, onClose, task }) {
  // ✅ ALL HOOKS AT TOP (NO CONDITIONS)
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [clientFeedback, setClientFeedback] = useState();
  const axiosPrivate = useAxiosPrivate();
  const [taskDetails, setTaskDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ Fetch only when task exists
  useEffect(() => {
    if (!task?.id) return;

    const option = {
      url: `om/get-all-details?taskId=${task.id}`,
      method: "get",
    };

    setLoading(true);
    axiosPrivate(option)
      .then((response) => {
        setTaskDetails(response?.data?.data?.taskDetails);
        setClientFeedback(response?.data?.data?.client_feedback);
      })
      .catch((error) => {
        console.error(error);
        setTaskDetails([]);
      })
      .finally(() => setLoading(false));
  }, [task?.id]);

  const InfoItem = ({ label, value }) => {
    if (value === null || value === undefined || value === "" || value === "-") {
      return null;
    }

    return (
      <MDBox>
        <MDTypography variant="caption" fontWeight="bold">
          {label} {" : "}
        </MDTypography>
        <MDTypography variant="caption" fontWeight="small">
          {value}
        </MDTypography>
      </MDBox>
    );
  };

  const formatTimestamp = (value) => {
    if (!value) return "-";
    const num = Number(value);
    if (Number.isNaN(num)) {
      console.warn("Invalid timestamp (NaN):", value);
      return "-";
    }
    const timestamp = value.toString().length === 10 ? num * 1000 : num;
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) {
      console.warn("Invalid date after conversion:", value);
      return "-";
    }
    return format(date, "dd-MM-yyyy hh:mm a");
  };

  const getMapUrl = (taskDetails) => {
    const lat = taskDetails?.latitude;
    const lng = taskDetails?.longitude;
    const address = taskDetails?.location;

    if (lat && lng) {
      return `https://www.google.com/maps?q=${lat},${lng}&z=15&output=embed`;
    }

    if (address) {
      return `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;
    }

    return null;
  };

  const mapUrl = getMapUrl(taskDetails);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: darkMode ? "#1a2035" : "#fff",
          color: darkMode ? "#fff" : "#000",
          borderRadius: 2,
        },
      }}
    >
      {/* HEADER */}
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: darkMode ? "#1f2937" : "#f5f5f5",
        }}
      >
        <MDTypography variant="h5">Task Details</MDTypography>
        <IconButton onClick={onClose}>
          <Icon>close</Icon>
        </IconButton>
      </DialogTitle>

      {/* CONTENT */}
      <DialogContent dividers>
        {!task ? (
          <MDTypography variant="caption">No task selected</MDTypography>
        ) : loading ? (
          <MDTypography variant="caption">Loading details...</MDTypography>
        ) : (
          <>
            <MDBox mb={3}>
              <MDTypography variant="h4" fontWeight="bold">
                {taskDetails?.lead_details?.leadName || ""}
              </MDTypography>

              <MDBox display="flex" gap={1} mt={1} flexWrap="wrap" alignItems="center">
                <MDTypography
                  variant="caption"
                  sx={{
                    backgroundColor: leadColors?.[taskDetails?.leadState] || "#9e9e9e",
                    color: "#fff",
                    px: 1.2,
                    py: 0.4,
                    borderRadius: "6px",
                    textTransform: "uppercase",
                  }}
                >
                  {taskDetails?.leadState}
                </MDTypography>

                <MDTypography variant="caption">
                  Assigned to: {taskDetails?.assigned_to || ""}
                </MDTypography>
              </MDBox>
            </MDBox>

            <MDBox
              display="grid"
              gridTemplateColumns="repeat(auto-fit, minmax(220px, 1fr))"
              gap={2}
            >
              <InfoItem label="Name" value={taskDetails?.lead_details?.leadName} />

              <InfoItem label="Mobile" value={taskDetails?.lead_details?.mobile1} />

              <InfoItem label="Alternate Mobile" value={taskDetails?.lead_details?.mobile2} />

              <InfoItem label="Task Type" value={taskDetails?.taskType} />

              <InfoItem label="Status" value={taskDetails?.status} />

              {/* Conditional: Comment vs Other Task */}
              {taskDetails?.taskType === "Comment" ? (
                <>
                  <InfoItem label="Added On" value={formatTimestamp(taskDetails?.taskCreatedOn)} />
                  <InfoItem label="Added By" value={taskDetails?.assigned_to} />
                </>
              ) : (
                <>
                  <InfoItem
                    label="Assigned On"
                    value={formatTimestamp(taskDetails?.taskCreatedOn)}
                  />
                  <InfoItem label="Assigned To" value={taskDetails?.assigned_to} />
                </>
              )}

              <InfoItem
                label="Completed On"
                value={formatTimestamp(taskDetails?.taskCompletedOn)}
              />

              <InfoItem label="Assigned By" value={taskDetails?.assigned_by} />

              <InfoItem label="Remark" value={taskDetails?.completion_remark} />

              <InfoItem label="Client Feedback" value={clientFeedback?.toUpperCase()} />
            </MDBox>
          </>
        )}

        {mapUrl && (
          <MDBox mt={3}>
            <MDTypography variant="h6" mb={1}>
              Location
            </MDTypography>

            <MDBox
              sx={{
                width: "100%",
                height: 280,
                borderRadius: 2,
                overflow: "hidden",
                border: "1px solid #ddd",
              }}
            >
              <iframe
                src={mapUrl}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </MDBox>
          </MDBox>
        )}
      </DialogContent>
    </Dialog>
  );
}

ActivityDetailsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  task: PropTypes.object,
};

export default ActivityDetailsModal;
